import styled from 'styled-components';
import { Button } from '@components/form-elements/buttons/Button';

export const BottomButton = styled(Button)`
  width: 25%;
  margin-right: 10px;
`;
